import { useTableActionContext } from '@aibees/elephant/context';
import { ElephantPresetType, SearchType } from '@aibees/elephant/types';

export function useExportTemplateDataType() {
  // Use the flow's effective search type (folds in the ActionButton override) so
  // the template columns match the record, not just the page route.
  const { integrationConfig, effectiveSearchType } = useTableActionContext();
  const isPeople = effectiveSearchType === SearchType.People;

  if (isPeople) {
    return integrationConfig
      ? ElephantPresetType.INTEGRATION_EXPORT_SETTINGS_COLUMNS
      : ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS;
  }

  // Company keeps its own columns even when an integration is configured, matching
  // the previous route-based precedence (company branch before people+integration).
  return ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS;
}
